<template>
<div>
  <div class="register-box">
    <div class="login-logo "><h2 class="text-white">Django-Advanced-Chat</h2></div>

    <div class="register-box-body">
      <p class="login-box-msg">Зарегистрируйтесь, чтобы протестировать мессенджер</p>

      <form method="post" @submit.prevent="preCreateAccount" class="form-element">
        <div class="form-group has-feedback">
          <input type="text" class="form-control" v-model.lazy="user_model.username" placeholder="Имя пользователя" required>
          <span class="ion ion-person form-control-feedback "></span>
          <span  class="error-field text-danger" v-show="registrationError"  v-for="error in fieldErrors('username')" :key="error">{{ error }}</span>
        </div>
        <div class="form-group has-feedback">
          <input type="email" class="form-control" v-model.lazy="user_model.email" placeholder="Email" required>
          <span class="ion ion-email form-control-feedback "></span>
          <span  class="error-field text-danger" v-show="registrationError"  v-for="error in fieldErrors('email')" :key="error">{{ error }}</span>
        </div>
        <div class="form-group has-feedback">
          <input type="password" class="form-control" v-model.lazy="user_model.password1" placeholder="Пароль" required>
          <span class="ion ion-locked form-control-feedback "></span>
          <p  class="error-field text-danger" v-show="registrationError" v-for="error in fieldErrors('password')" :key="error">{{ error }}</p>
        </div>
        <div class="form-group has-feedback">
          <input type="password" class="form-control" v-model.lazy="user_model.password2" placeholder="Повтор пароля" required>
          <span class="ion ion-log-in form-control-feedback "></span>
          <span class="error-field text-danger" v-show="registrationError" v-for="error in fieldErrors('password2')" :key="error">{{ error }}</span>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="checkbox">
              <input type="checkbox" v-model="agree" id="basic_checkbox_1" >
              <label for="basic_checkbox_1">Принимаю пользовательское соглашение</label>
            </div>
            <span  class="error-field text-danger" v-show="agree_error" >Подтвердите пользовательское соглашение, чтобы зарегистрироваться</span>
          </div>
          <!-- /.col -->
          <div class="col-12 text-center">
            <div class="alert alert-danger" role="alert" v-show="registrationError" v-for="error in fieldErrors('non_field_errors')" :key="error">
                {{ error }}
            </div>
          </div>
          <div class="col-12 text-center">
            <button type="submit" class="btn btn-info btn-block btn-flat margin-top-10">Зарегистрироваться</button>
          </div>
          <!-- /.col -->
        </div>
      </form>

       <div class="margin-top-20 text-center">
        <p>Уже есть аккаунт?<a href="/login" class="text-info m-l-5"> Войти</a></p>
       </div>

    </div>
    <!-- /.form-box -->
  </div>
  <!-- /.register-box -->
</div>
</template>

<script>
	import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
  import {REGISTRATION_FAILURE} from "@/store/modules/types";

	export default  {
		data: function(){
			return{
				user_model:{
          username: '',
          password1: '',
          password2: '',
          email: '',
				},
        agree: true,
        agree_error: false,
        register_form: true
			}
		},
    computed: mapState('signup', [
      'registrationCompleted',
      'registrationError',
      'errors',
      'registrationLoading',
    ]),
    methods: {
      ...mapActions('signup', [
      'createAccount',
      'clearRegistrationStatus',
    ]),
    preCreateAccount: function(){
      if (this.agree){
        if(this.user_model.password1 === this.user_model.password2) {
           const formatted_user_model = {
              'username': this.user_model.username,
              'password': this.user_model.password1,
              'email': this.user_model.email
          }
          this.createAccount(formatted_user_model);
        } else {
          const data = {
            "password2": "Пароли должны совпадать"
          }
          this.$store.commit('signup/'+REGISTRATION_FAILURE, data)
        }

      }else{
        this.agree_error = true
      }

    },
    beforeRouteLeave(to, from, next) {
      this.clearRegistrationStatus();
      next();
    },
    goToIndex: function(){
      this.$router.push('/')
    },
    fieldErrors: function (field) {
      if (field in this.errors) {
        return this.errors[field]
      }
      return []
    },
    },
	}
</script>

<style scoped>

</style>